import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {ReplaySubject} from 'rxjs';
import {Note} from '../../../shared/interface/note';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {NoteService} from '../../../shared/services/note.service';

@Component({
  selector: 'app-note-details',
  templateUrl: './note-details.component.html',
  styleUrls: ['./note-details.component.scss']
})
export class NoteDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  uuid?: string = null;
  noteObject?: Note;
  note: ReplaySubject<Note> = new ReplaySubject<Note>(1);
  modify = false;

  constructor(
    private route: ActivatedRoute,
    private noteService: NoteService,
    private snack: MatSnackBar,
  ) {
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.uuid = params.id;
        this.loadNote();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
  }

  loadNote(): void {
    this.noteService.getNote(this.uuid).subscribe((note: Note) => {
      this.note.next(note);
      this.noteObject = note;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych notatki', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
